module.exports = __webpack_public_path__ + "name=img/src/assets/projects/design/settings.png?486e67b5d81df7aa99248b14f1f4c38e";